import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { SocialLinkSchema } from "@/components/forms/schemas/social-link";
import { relatedArtistSchema } from "@/pages/artists/schemas/artist.related";

export const artistSpotifyStatsSchema = z.object({
  popularity: z.number().nullish(),
  followers: z.number().nullish(),
  monthlyListeners: z.number().nullish(),
  topCities: z
    .array(
      z.object({
        city: z.string(),
        numberOfListeners: z.number(),
        country: z.string(),
        region: z.string(),
      }),
    )
    .nullish(),
});

export const artistSpotifyEnrichmentSchema = z.object({
  id: z.string(),
  imageUrl: z.string().url().nullish(),
  galleryImagesUrl: z.array(z.string().url()).nullish(),
  genres: z.array(z.string()).nullish(),
  bio: z
    .string()
    .nullish()
    .superRefine(
      fieldConfig({
        fieldType: "textarea",
      }),
    ),
  socialLinks: z.array(SocialLinkSchema).nullish(),
  relatedArtists: z.array(relatedArtistSchema).nullish(),
  stats: artistSpotifyStatsSchema,
  updatedAt: z.string().datetime({ offset: true }),
});
